import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from 'syf-component-library/ui/atoms/Link';
import styled from 'styled-components';
import CardInfo from '../../components/cards/CardInfo';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { Paragraph } from '../../components/Styled/typography';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import { t } from '../../translations/getTranslation';
import { contactNumber } from '../../const/customerCareNumber';
const ContactNumberLink = styled(Link) `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: 0;
  display: inline;
`;
const ExitConfirmation = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    useAnalytics(isSuccess, { isSemu });
    return (_jsxs("div", Object.assign({ "data-cy": "exit-confirmation-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, { title: t('exitConfirmation.exitingWillCancel'), modalImageProps: {
                            imageName: 'WARNING'
                        } }), _jsxs(Paragraph, { children: [t('exitConfirmation.changingYourAddress'), _jsx(ContactNumberLink, Object.assign({ href: `tel:${contactNumber}`, "data-type": "replacement card", "data-reason": "phone number", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: contactNumber })), "."] })] }))] })));
};
export default ExitConfirmation;
//# sourceMappingURL=index.js.map